export default "__VITE_ASSET__a4f59a2b__"